import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzTagModule } from 'ng-zorro-antd/tag';

@Component({
    selector: 'app-status-view',
    template: `
    <nz-tag>
      <ng-container [ngSwitch]="status">
        <ng-container *ngSwitchCase="'DRAFT'">Черновик</ng-container>
        <ng-container *ngSwitchCase="'NEW'">Новый</ng-container>
        <ng-container *ngSwitchCase="'ON_SIGNATURE'">На подписании</ng-container>
        <ng-container *ngSwitchCase="'SIGNED'">Подписан, на освидетельствовании</ng-container>
        <ng-container *ngSwitchCase="'ON_APPROVAL'">На согласовании у руководителя</ng-container>
        <ng-container *ngSwitchCase="'APPROVAL'">На согласовании</ng-container>
        <ng-container *ngSwitchCase="'APPROVAL_REJECTED'">Отказан при освидетельствовании</ng-container>
        <ng-container *ngSwitchCase="'SIGNATURE'">На подписании</ng-container>
        <ng-container *ngSwitchCase="'APPROVED'">Одобрен</ng-container>
        <ng-container *ngSwitchCase="'ON_REVOKE'">На отзыве</ng-container>
        <ng-container *ngSwitchCase="'REVOKED'">Отозван</ng-container>
        <ng-container *ngSwitchCase="'SIGN_REJECTED'">Отказан при подписании</ng-container>
        <ng-container *ngSwitchCase="'PROCESSED'">Обработано</ng-container>
        <ng-container *ngSwitchCase="'PROCESSED_ELICENSE'">Обработано в ГБД ЕЛ</ng-container>
        <ng-container *ngSwitchCase="'REWORK'">Не одобрено руководителем, на доработке</ng-container>
        <ng-container *ngSwitchCase="'SENT'">Отправлен</ng-container>
        <ng-container *ngSwitchCase="'ACCEPTED'">Принят без замечаний</ng-container>
        <ng-container *ngSwitchCase="'DECLINED'">Принят с замечаниями</ng-container>
        <ng-container *ngSwitchCase="'REJECTED'">Отказан в согласовании</ng-container>
        <ng-container *ngSwitchDefault>{{status}}</ng-container>
      </ng-container>
    </nz-tag>
  `,
    imports: [
        CommonModule,
        NzTagModule,
    ]
})
export class StatusViewComponent {

  @Input()
  status?: string;
}
